export default __webpack_public_path__ + "static/media/x_wdt_c_2.72e5c20b.mp3";